import React from 'react'

type Props = React.SVGProps<SVGSVGElement>

function DocumentIcon(
  props: Props
): JSX.Element {

  return (
    <svg
      { ...props }
      className="icon reveleer-document"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.01 2C0.01 0.9 0.9 0 2 0H10L16 6V18C16 19.1 15.1 20 14 20H1.99C0.89 20 0 19.1 0 18L0.01 2ZM9 1.5V7H14.5L9 1.5Z"
        fill='#000000'
      />
    </svg>
  )
}

export default DocumentIcon
